import { PlanetTutorial } from '@components/tutorial/PlanetTutorial';
import { FactionInfo } from '@components/helpers/FactionInfo';
import { PlanetInfo } from '@components/helpers/PlanetInfo';
import { ComplexInfo } from '@components/lobby/ComplexInfo';
import { useHistoryInterceptor } from '@helpers/history';
import { LootInfo } from '@components/helpers/LootInfo';
import { useLobbyStore, useAppStore } from '@stores';
import { Glitch } from '@components/helpers/Glitch';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useStartGameMutation } from '@http';

export function Lobby() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Lobby' });
  const { mutateAsync } = useStartGameMutation();
  const { tab, setTab } = useAppStore();
  const { state } = useLobbyStore();

  useHistoryInterceptor(() => {
    setTab('navigation');
    return true;
  }, { disabled: tab === 'navigation' });

  const start = () => mutateAsync();
  const goToNavigation = () => setTab('navigation');

  if (!state) return (
    <div className="flex justify-center py-12">
      <Glitch><span className="loader" /></Glitch>
    </div>
  );

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <PlanetInfo onClick={goToNavigation} mission={state.mission} name={state.planet} />
      <PlanetTutorial />

      {state.planet !== 'Complex' && (
        <div className="flex-1 overflow-auto">
          <LootInfo mission={state.mission} planet={state.planet} />
          <FactionInfo mission={state.mission} planet={state.planet} />
        </div>
      )}

      {state.planet === 'Complex' && (
        <div className="flex-1 overflow-auto">
          <ComplexInfo />
        </div>
      )}

      <Button
        className="h-12 border-x-0 border-b-0 font-bold bg-primary text-black land-btn"
        disabled={!state.planet}
        onClick={start}
        glitch
      >
        {state.countdown ? state.countdown : (
          state.planet === 'Complex' ? t('enter') : t('land')
        )}
      </Button>
    </div>
  );
}